import store from '@/store/store';

const entityName = () => {
  const user = store.getters['auth/user'];

  if (user) {
    return user.company.CompanyName;
  }

  return '';
}

// en, de, fr, pt
export default {
  en: {
    Dashboard: 'Dashboard',
    DataCentre: 'Data Centre',
    DataCentreReports: 'Data Centre Reports',
    ReturnToFides: 'Return to FIDES',
    UnderwritingTools: 'Underwriting Tools',
    Portfolio: 'Portfolio',
    WorkInProgress: 'Work in Progress',
    Production: 'Production',
    Submissions: 'Submissions',
    Contacts: 'Contacts',
    Details: 'Details',
    UploadFirmOrders: 'Upload Firm Orders',
    ID: 'ID',
    IssueDate: 'Issue Date',
    CertificateNumber: 'Certificate Number',
    UserSubUser: 'User/Sub-user',
    Name: 'Name',
    Surname: 'Surname',
    CompanyName: 'Company Name',
    ClassOfRisk: 'Class of Risk',
    InceptionDate: 'Inception Date',
    ExpiryDate: 'Expiry Date',
    Limit: 'Limit',
    Excess: 'Excess',
    RetroactivityDate: 'Retroactivity Date',
    RetroactivityNarrative: 'Retroactivity Narrative',
    Status: 'Status',
    FinalPremium: 'Final Premium',
    NumberOfCertificates: 'Number of Certificates',
    DownloadCertificate: 'Certificate',
    SubmitterName: 'Submitter Name',
    InsuredFirstName: 'Insured First Name',
    InsuredCompanyName: 'Insured Company Name',
    InsuredFiscalCode: 'Fiscal Code',
    InsuredVATCode: 'VAT Code',
    DateOfSubmission: 'Date of Submission',
    SubmissionCode: 'Submission Code',
    InsuredLastName: 'Insured Last Name',
    SentToInsured: 'Sent To Insured',
    Referral: 'Referral',
    Renewal: 'Renewal',
    SubmissionNote: 'Submission Note',
    SentDate: 'Sent Date',
    LimitOfIndemnity: 'Limit of Indemnity',
    eCommerce: 'eCommerce',
    Apps: 'Apps',
    Todo: 'Todo',
    Chat: 'Chat',
    Email: 'Email',
    Calendar: 'Calendar',
    FullCalendar: 'Full Calendar',
    SimpleCalendar: 'Simple Calendar',
    Shop: 'Shop',
    ItemDetails: 'Item Details',
    AddYourDetails: 'Add your details',
    AddYourEmailAddress: 'Add your email address',
    Cart: 'Cart',
    WishList: 'Wish List',
    Checkout: 'Checkout',
    UI: 'UI',
    DataList: 'Data List',
    ListView: 'List View',
    ThumbView: 'Thumb View',
    Grid: 'Grid',
    Vuexy: 'Vuexy',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Colors',
    Card: 'Card',
    Basic: 'Basic',
    Statistics: 'Statistics',
    Analytics: 'Analytics',
    CardActions: 'Card Actions',
    CardColors: 'Card Colors',
    Table: 'Table',
    agGridTable: 'agGrid Table',
    Components: 'Components',
    Alert: 'Alert',
    Avatar: 'Avatar',
    Badge: 'Badge',
    Breadcrumb: 'Breadcrumb',
    Button: 'Button',
    ButtonGroup: 'Button Group',
    Chip: 'Chip',
    Collapse: 'Collapse',
    Dialogs: 'Dialogs',
    Divider: 'Divider',
    DropDown: 'DropDown',
    List: 'List',
    Loading: 'Loading',
    Navbar: 'Navbar',
    Notifications: 'Notifications',
    Pagination: 'Pagination',
    Popup: 'Popup',
    Progress: 'Progress',
    Sidebar: 'Sidebar',
    Slider: 'Slider',
    Tabs: 'Tabs',
    Tooltip: 'Tooltip',
    Upload: 'Upload',
    FormsAndTable: 'Forms & Table',
    FormElements: 'Form Elements',
    Select: 'Select',
    Switch: 'Switch',
    Checkbox: 'Checkbox',
    Radio: 'Radio',
    Input: 'Input',
    NumberInput: 'Number Input',
    Textarea: 'Textarea',
    FormLayouts: 'Form Layouts',
    FormWizard: 'Form Wizard',
    FormValidation: 'Form Validation',
    FormInputGroup: 'Form Input Group',
    Pages: 'Pages',
    Authentication: 'Authentication',
    Login: 'Login',
    Register: 'Register',
    ForgotPassword: 'Forgot Password',
    ResetPassword: 'Reset Password',
    LockScreen: 'Lock Screen',
    Miscellaneous: 'Miscellaneous',
    ComingSoon: 'Coming Soon',
    Error: 'Error',
    404: '404',
    500: '500',
    NotAuthorized: 'Not Authorized',
    Maintenance: 'Maintenance',
    Profile: 'Profile',
    User: 'User',
    View: 'View',
    Edit: 'Edit',
    UserSettings: 'User Settings',
    Invoice: 'Invoice',
    FAQ: 'FAQ',
    Search: 'Search',
    KnowledgeBase: 'Knowledge Base',
    ChartsAndMaps: 'Charts & Maps',
    Charts: 'Charts',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Map',
    Extensions: 'Extensions',
    QuillEditor: 'Quill Editor',
    DragAndDrop: 'Drag & Drop',
    Datepicker: 'Datepicker',
    DatetimePicker: 'Datetime Picker',
    AccessControl: 'Access Control',
    I18n: 'I18n',
    Carousel: 'Carousel',
    Clipboard: 'Clipboard',
    ContextMenu: 'Context Menu',
    StarRatings: 'Star Ratings',
    Autocomplete: 'Autocomplete',
    Tree: 'Tree',
    // "Import/Export": 'Import/Export',
    Import: 'Import',
    Export: 'Export',
    ExportSelected: 'Export Selected',
    Others: 'Others',
    MenuLevels: 'Menu Levels',
    MenuLevel2p1: 'Menu Level 2.1',
    MenuLevel2p2: 'Menu Level 2.2',
    MenuLevel3p1: 'Menu Level 3.1',
    MenuLevel3p2: 'Menu Level 3.2',
    DisabledMenu: 'Disabled Menu',
    Support: 'Support',
    Documentation: 'Documentation',
    RaiseSupport: 'Raise Support',
    demoTitle: 'Card Title',
    demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.',
    Product: 'Product',
    Document: 'Document',
    OtherDocuments: 'Other Documents',
    Actions: 'Actions',
    DownloadSelected: 'Download Selected',
    RecentUploads: 'Recent Uploads',
    RecentDownloads: 'Recent Downloads',
    Username: 'Username',
    AssociatedCompany: 'Associated Company',
    Active: 'Active',
    Copyright: 'Copyright',
    AllRightsReserved: 'All Rights Reserved',
    FirmOrderSubmission: 'Firm Order Submission',
    Title: 'Title',
    FirstName: 'First Name',
    LastName: 'Last Name',
    CountryCode: 'Country Code',
    TelephoneNumber: 'Telephone Number',
    Ext: 'Ext',
    Optional: 'Optional',
    EmailAddress: 'Email address',
    EnterYourEmailAddress: 'Enter your email address',
    AdditionalEmailAddresses: 'Additional email addresses',
    EmailAddressCertificate: 'Where would you like to receive the certificate?',
    SendCertificateToProposer: 'Send a copy of the certificate to the insured',
    SubmissionType: 'Type of Submission',
    RemoteSignature: 'Remote Signature',
    StandardSignature: 'Standard Signature',
    AttachRater: 'Attach the Rater',
    AttachProposal: 'Attach the complete proposal form in all its parts',
    ChooseFile: 'Choose File',
    FurtherAttachments: 'Further Attachments',
    DropFilesHereToUpload: 'Drop files here to upload',
    Attachments: 'Attachments',
    Remove: 'Remove',
    Notes: 'Notes or special request',
    ReadTheDisclaimer: 'Read the disclaimer',
    Disclaimer: 'Disclaimer',
    DisclaimerText1: entityName() + ' confirms that it assumes responsibility for all correspondence of the specific coverage options and the submitted form correctly reflects the clients requests, especially where the Proposal Form is completed separately and/or signed without the aid of the remote signature tool.',
    DisclaimerText2: entityName() + ' also confirms that the information contained in the attached Quotation and Proposal Form (where this constitutes a separate document) is to the best of its knowledge, true and complete',
    IAgreeToTheTermsAndConditions: 'I agree to the terms and conditions',
    Submit: 'Submit',
    Cancel: 'Cancel',
    SendRequestToIssuePolicy: 'Send request to issue policy',
    ConfirmAndSubmit: 'Confirm & Submit',
    Signed: 'Signed',
    ResetForm: 'Reset Form',
    UploadComplete: 'Upload Complete',
    UploadSuccessMessage: 'Documents uploaded successfully',
    ErrorOccurred: 'Error Occurred',
    UploadFailureMessage: 'Not able to upload documents. Please try again.',
    CategoriesFetchFailureMessage: 'Not able to retrieve categories. Please try again.',
    DocumentTypesFetchFailureMessage: 'Not able to retrieve document types. Please try again. ',
    DownloadNoItemsSelectedMessage: 'Please select one or more items.',
    UsersFetchFailureMessage: 'Not able to retrieve list of users. Please try again.',
    DashboardChartFailureMessage: 'Not able to retrieve chart data. Please try again',
    UploadMultiUploadText: 'Choose a file or drop it in here',
    UploadMultiUploadTextBefore: 'Drop files here or',
    UploadMultiUploadTextAfter: 'to upload',
    ClickHere: 'click here',
    DownloadFileFailureMessage: 'Not able to download file. Please try again.',
    DownloadSuccessMessage: 'This file is ready to download',
    DownloadEmailSuccessMessage: 'Your download is processing and a link will be emailed to you upon completion.',
    Close: 'Close',
    UnableToLoadDataset: 'Unable to load dataset',
    Download: 'Download',
    ConfirmDownload: 'Confirm Download',
    ConfirmDownloadMessage: 'Are you sure you wish to download these items?',
    InvalidFileType: 'Invalid File Type',
    InvalidFileSize: 'Invalid file size. Maximum size is',
    ExcelRaterFileTypesAllowed: 'Only .xlsx and .xlsm files are allowed.',
    ProposalFileTypesAllowed: 'Only .docx and .pdf files are allowed.',
    SubmissionDate: 'Submission Date',
    CertificatePolicyNo: 'Certificate No',
    InsuredSurname: 'Surname',
    ClassOfBusiness: 'Class of Business',
    Profession: 'Profession',
    AddressLine1: 'Address',
    GeneratedServiceCode: 'Submission No',
    SubmissionStatus: 'Status',
    IsRemoteSignature: 'Remote Signature',
    IsReferral: 'Referral',
    SubmitterNote: 'Producer Note',
    PolicyIssueDate: 'Policy Issued Date',
    InsuredTurnover: 'Insured Turnover',
    RetroactiveDate: 'Retroactive Date',
    RetroactivePeriod: 'Retroactive Period',
    Raters: 'Raters',
    IPID: 'IPID',
    ProductSheet: 'Product Sheet',
    ProposalForm: 'Proposal Form',
    InformationBooklet: 'Info Booklet',
    Wording: 'Wording ',
    DownloadAllOfflineRaters: 'Download all Offline Raters',
    StandardSignatureText: 'Requires uploading of the Rater and Proposal form.  Policy will be issued within 48 hours',
    RemoteSignatureText: 'Requires uploading of the Rater only.  When the Proposer signs electronically, the Policy will be issued immediately.',
    UploadFormExcelProposal: 'Upload Excel Rater and Proposal Form',
    UploadFormExcel: 'Upload Excel Rater',
    FirmOrderSubmitted: 'Firm Order Submitted',
    ThankYouForYourSubmission: 'Thank you for your submission',
    ViewSubmission: 'View submission',
    UploadAnother: 'Upload another',
    UploadFailed: 'Download failed',
    UploadFailedMessage: 'Please go back or retry your download below',
    Retry: 'Retry',
    SelectSignature: 'Select Signature',
    AddYourFileSingular: 'Add your file',
    AddYourFilePlural: 'Add your files',
    DownloadComplete: 'Download complete',
    YourDownloadIsReady: 'Your download is ready',
    ClickLinkToDownload: 'Click on the link below to start downloading',
    DownloadFile: 'Download file',
    DownloadingFile: 'Downloading File',
    ProcessingDownload: 'We are processing your download...',
    DownloadingMessage: 'Once your download is ready, a link will appear below. Please keep this tab active. ',
    ProcessCanTakeFewMinutes: 'This process can take few minutes...',
    Ready: 'Ready',
    Failed: 'Failed',
    DownloadFailed: 'Download failed',
    SomethingWentWrong: 'Something went wrong...',
    NoRecordsFound: 'No records found…',
    GoBackToUnderwritingTools: 'Please go back and try the download again',
    PleaseContactHelpDesk: 'Please contact helpdesk@fides.international for additional support',
    ReturnToUnderwritingTools: 'Return',
    SelectOption: 'Select option',
    FirmOrderAndReferrals: 'Firm Order and Referrals',
    RequestNotProperlyReceived: 'Request not properly received',
    Back: 'Back',
},
  it: {
    Dashboard: 'Piattaforma di Sottoscrizione',
    UnderwritingTools: 'Strumenti di sottoscrizione',
    Portfolio: 'Portafoglio',
    WorkInProgress: 'Lavori in corso',
    Production: 'Produzione',
    Submissions: 'Presentazioni',
    Contacts: 'Contatti',
    Details: 'Dati',
    AddYourDetails: 'Aggiungi i tuoi dati',
    AddYourEmailAddress: 'Inserisci indirizzo email',
    UploadFirmOrders: 'Carica Ordine Fermo',
    Upload: 'Caricare',
    Search: 'Cerca',
    IssueDate: 'Data di rilascio',
    CertificateNumber: 'Numero di certificato',
    UserSubUser: 'Utente',
    Name: 'Nome',
    Surname: 'Cognome',
    CompanyName: 'Società',
    ClassOfRisk: 'Classe di Rischio',
    InceptionDate: 'Decorrenza',
    ExpiryDate: 'Scadenza',
    Limit: 'Massimale',
    Excess: 'Franchigia',
    RetroactivityDate: 'Retroattivitá',
    RetroactivityNarrative: 'Retroattivitá ILLIMITATA',
    Status: 'Stato',
    FinalPremium: 'Premio Lordo',
    NumberOfCertificates: 'Numero di certificati',
    DownloadCertificate: 'Download',
    SubmitterName: 'Nome dell\'Operatore',
    InsuredFirstName: 'Nome',
    InsuredCompanyName: 'Società',
    InsuredFiscalCode: 'Codice Fiscale',
    InsuredVATCode: 'Partita IVA',
    DateOfSubmission: 'Data della richiesta',
    SubmissionCode: 'ID',
    InsuredLastName: 'Cognome dell\'Assicurato',
    SentToInsured: 'Certificato inviato all\'Assicurato?',
    Referral: 'Referral',
    Renewal: 'Rinnovo',
    SubmissionNote: 'Note',
    SentDate: 'Inviato',
    LimitOfIndemnity: 'Massimale',
    Product: 'Prodotto',
    Document: 'Documento',
    OtherDocuments: 'Modulistica',
    Actions: 'Azioni',
    DownloadSelected: 'Download Selezionato',
    RecentUploads: 'Caricamenti Recenti',
    RecentDownloads: 'Download Recenti',
    Username: 'Nome Utente',
    AssociatedCompany: 'Società Associata',
    Active: 'Attivo',
    Copyright: 'Diritto d\'autore',
    AllRightsReserved: 'All Rights Reserved',
    FirmOrderSubmission: 'Firm Order Submission',
    Title: 'Titolo',
    FirstName: 'Nome',
    LastName: 'Cognome dell\' Operatore',
    CountryCode: 'Prefisso Internazionale',
    TelephoneNumber: 'Telefono dell\'Operatore',
    Ext: 'Ext',
    Optional: 'Opzionale',
    EmailAddress: 'Indirizzo Email',
    EnterYourEmailAddress: 'Indica il tuo indirizzo email',
    AdditionalEmailAddresses: 'Indirizzio e-mail aggiuntivo',
    EmailAddressCertificate: 'A quale indirizzo email vuoi ricevere il certificato?',
    SendCertificateToProposer: 'Invia copia del certificato all\'assicurato',
    SubmissionType: 'Tipo di Emissione',
    RemoteSignature: 'Firma Remota',
    StandardSignature: 'Firma Autografa',
    AttachRater: 'Allegare il Preventivatore',
    AttachProposal: 'Allegare Modulo di proposta completo in tutte le sue parti',
    ChooseFile: 'Scegli un file',
    FurtherAttachments: 'Ulteriore allegato',
    DropFilesHereToUpload: 'Drop files here to upload',
    Attachments: 'Allegati',
    Remove: 'Rimuovi',
    Notes: 'Note o richieste particolari',
    ReadTheDisclaimer: 'Leggi il Disclaimer',
    Disclaimer: 'Disclaimer',
    DisclaimerText1: entityName() + ' si assume la responsabilita’ della rispondenza delle specifiche opzioni di copertura selezionate all’interno del Preventivatore alle effettive scelte d’acquisto del Proponente - Assicurando, specificamente laddove il Modulo di Proposta sia un documento compilato separatamente e/o firmato senza l’ausilio dello strumento della firma remota.',
    DisclaimerText2: entityName() + ' conferma inoltre che le informazioni contenute nell’allegato Preventivatore e nel Modulo di Proposta (ove questo costituisca documento separato) sono, per quanto a sua conoscenza, veritiere e complete.',
    IAgreeToTheTermsAndConditions: 'Accetto Termini e Condizioni',
    Submit: 'Invia',
    Cancel: 'Annulla',
    SendRequestToIssuePolicy: 'Envia Richiesta di Emissione',
    ConfirmAndSubmit: 'Conferma & Invia',
    Signed: 'Firmato',
    ResetForm: 'Reimposta modulo',
    UploadComplete: 'Caricamento Completato',
    UploadSuccessMessage: 'Documenti caricati correttamente',
    ErrorOccurred: 'Errore',
    UploadFailureMessage: 'Caricamento documenti fallito. Provare di nuovo.',
    CategoriesFetchFailureMessage: 'Impossibile recuperare le categorie. Per favore riprova.',
    DocumentTypesFetchFailureMessage: 'Impossibile recuperare i tipi di documento. Provare di nuovo.',
    DownloadNoItemsSelectedMessage: 'Seleziona uno o più elementi.',
    UsersFetchFailureMessage: 'Impossibile recuperare l\'elenco di utenti. Provare di nuovo.',
    DashboardChartFailureMessage: 'Impossibile recuperare i dati del grafico. Riprova',
    UploadMultiUploadText: 'Scegli un file o inseriscilo qui',
    UploadMultiUploadTextBefore: 'Trascina il file qui o',
    UploadMultiUploadTextAfter: 'da caricare',
    ClickHere: 'clicca qui',
    DownloadFileFailureMessage: 'Impossibile scaricare il file. Provare di nuovo.',
    DownloadSuccessMessage: 'Questo file è pronto per il download',
    DownloadEmailSuccessMessage: 'Il download è in fase di elaborazione e al completamento ti verrà inviato un link tramite e-mail.',
    Close: 'Chiudi',
    UnableToLoadDataset: 'Impossibile caricare i dati',
    Download: 'Download',
    ConfirmDownload: 'Conferma il download',
    ConfirmDownloadMessage: 'Sei sicuro di volere scaricare questi elementi?',
    InvalidFileType: 'Tipo di file non valido',
    InvalidFileSize: 'Dimensione del file non valida. La dimensione massima è ',
    ExcelRaterFileTypesAllowed: 'Sono consentiti solo file .xlsx e .xlsm',
    ProposalFileTypesAllowed: 'Sono consentiti solo file .docx e .pdf',
    SubmissionDate: 'Data della Richiesta',
    CertificatePolicyNo: 'Numero di Certificato',
    InsuredSurname: 'Cognome',
    ClassOfBusiness: 'Classe di Business',
    Profession: 'Professione',
    AddressLine1: 'Indirizzo',
    GeneratedServiceCode: 'Richiesta Numero',
    SubmissionStatus: 'Status',
    IsRemoteSignature: 'Firma Digital',
    IsReferral: 'Referral',
    SubmitterNote: 'Note',
    PolicyIssueDate: 'Data di emissione della Polizza',
    InsuredTurnover: 'Fatturato',
    RetroactiveDate: 'Retroattività',
    RetroactivePeriod: 'Periodo di Retroattività',
    Raters: 'Raters',
    IPID: 'DIP',
    ProductSheet: 'Scheda Prodotto',
    ProposalForm: 'Questionario',
    InformationBooklet: 'Libretto Informativo',
    Wording: 'Testo di Polizza',
    DownloadAllOfflineRaters: 'Scarica Offline Raters',
    StandardSignatureText: 'Caricamento di preventivatore e modulo di proposta con emissione in 48 ore.',
    RemoteSignatureText: 'Caricamento del solo preventivatore, emissione immediata nel momento in cui il Proponente appone la propria firma elettronicamente.',
    UploadFormExcelProposal: 'Carica Excel Rater e Questionario',
    UploadFormExcel: 'Carica Excel Rater',
    FirmOrderSubmitted: 'Ordine Fermo inviato',
    ThankYouForYourSubmission: 'Grazie per la tua richiesta',
    ViewSubmission: 'Visualizza Ordine Fermo',
    UploadAnother: 'Carica un altro',
    UploadFailed: 'Download fallito',
    UploadFailedMessage: 'Si prega di tornare agli Strumenti di sottoscrizione o di riprovare il download qui sotto',
    Retry: 'Riprova',
    SelectSignature: 'Seleziona la tipologia di emissione',
    AddYourFileSingular: 'Aggiungi il file',
    AddYourFilePlural: 'Aggiungi i file',
    DownloadComplete: 'Download completo',
    YourDownloadIsReady: 'Il tuo download è pronto',
    ClickLinkToDownload: 'Clicca sul link qui sotto per scaricare il file',
    DownloadFile: 'Scarica il file',
    DownloadingFile: 'Scaricamento del file',
    ProcessingDownload: 'Stiamo elaborando il tuo download',
    DownloadingMessage: 'Una volta che il tuo download è stato completato, un link apparirà qui sotto. Si prega di tenere questa scheda attiva. ',
    ProcessCanTakeFewMinutes: 'Questo processo può richiedere pochi minuti',
    Ready: 'Ready',
    Failed: 'Errore',
    DownloadFailed: 'Scaricamento fallito',
    SomethingWentWrong: 'Qualcosa è andato storto',
    NoRecordsFound: 'Nessun record trovato…',
    GoBackToUnderwritingTools: 'Si prega di tornare agli Strumenti di sottoscrizione o di riprovare il download qui sotto',
    PleaseContactHelpDesk: 'Per supporto contattare helpdesk@fides.international for additional',
    ReturnToUnderwritingTools: 'Ritorna agli Strumenti di sottoscrizione',
    SelectOption: 'Seleziona un’opzione',
    FirmOrderAndReferrals: 'Ordini Fermi e Referrals',
    RequestNotProperlyReceived: 'Richieste non processate',
  },
  es: {
    Dashboard: 'Plataforma de suscripción',
    UnderwritingTools: 'Herramientas de suscripción',
    Portfolio: 'Cartera',
    WorkInProgress: 'Trabajos en elaboración',
    Production: 'Producción',
    Submissions: 'Envíos',
    Contacts: 'Contacto',
    Details: 'Datos',
    AddYourDetails: 'Agrega tus datos',
    AddYourEmailAddress: 'Incluye tu dirección de email',
    UploadFirmOrders: 'Subir Firm Order',
    Upload: 'Cargar',
    Search: 'Buscar',
    IssueDate: 'Fecha de emisión',
    CertificateNumber: 'Número de certificado',
    UserSubUser: 'Usuario/Subusuario',
    Name: 'Nombre',
    Surname: 'Apellido',
    CompanyName: 'Nombre de la empresa',
    ClassOfRisk: 'Clase del riesgo',
    InceptionDate: 'Fecha de inicio',
    ExpiryDate: 'Fecha de expiración',
    Limit: 'Límite',
    Excess: 'Franquicia',
    RetroactivityDate: 'Fecha de retroactividad',
    RetroactivityNarrative: 'Narrativa de la retroactividad',
    Status: 'Estado',
    FinalPremium: 'Prima Total',
    NumberOfCertificates: 'Número de Póliza',
    DownloadCertificate: 'Descargar Póliza',
    SubmitterName: 'Nombre de la persona que presenta la solicitud',
    InsuredFirstName: 'Nombre del asegurado',
    InsuredCompanyName: 'Nombre de la empresa asegurada',
    InsuredFiscalCode: 'Código fiscal',
    InsuredVATCode: 'Código del IVA',
    DateOfSubmission: 'Fecha de solicitud',
    SubmissionCode: 'Código de la solicitud',
    InsuredLastName: 'Apellido  del asegurado',
    SentToInsured: 'Enviado a asegurado',
    Referral: 'Referral',
    Renewal: 'Renovación',
    SubmissionNote: 'Notas de la solicitud',
    SentDate: 'Fecha de envío',
    LimitOfIndemnity: 'Límite de indemnización',
    Product: 'Producto',
    Document: 'Documento',
    OtherDocuments: 'Otros documentos',
    Actions: 'Acciones',
    DownloadSelected: 'Descarga seleccionada',
    RecentUploads: 'Subidas recientes',
    RecentDownloads: 'Descargas recientes',
    LastWeek: 'La semana pasada',
    OneWeekAgo: 'Hace una semana',
    TwoWeeksAgo: 'Hace dos semanas',
    ThreeWeeksAgo: 'Hace tres semanas',
    Username: 'Nombre de usuario',
    AssociatedCompany: 'Empresa asociada',
    Active: 'Activo',
    Copyright: 'Copyright',
    AllRightsReserved: 'Todos los derechos reservados',
    FirmOrderSubmission: 'Presentación de pedido en firme',
    Title: 'Título',
    FirstName: 'Nombre',
    LastName: 'Apellido',
    CountryCode: 'Prefijo Internacional',
    TelephoneNumber: 'Número de teléfono',
    Ext: 'Ext',
    Optional: 'Opcional',
    EmailAddress: 'Dirección de email',
    EnterYourEmailAddress: 'Indique su dirección de email',
    AdditionalEmailAddresses: 'Indirizzi email aggiuntivi',
    EmailAddressCertificate: '¿En qué dirección desea recibir la póliza?',
    SendCertificateToProposer: 'Enviar una copia del seguro al asegurado',
    SubmissionType: 'Tipo de Emisión',
    RemoteSignature: 'Firma Digital',
    StandardSignature: 'Firma Manual',
    AttachRater: 'Excel de tarificación',
    AttachProposal: 'Adjuntar el formulario de propuesta completo en todas sus partes',
    ChooseFile: 'Elige fichero',
    FurtherAttachments: 'Adjuntos adicionales',
    DropFilesHereToUpload: 'Arrastrar los archivos aquí para subirlos',
    Attachments: 'Adjuntos',
    Remove: 'Eliminar',
    Notes: 'Notas',
    ReadTheDisclaimer: 'Leer el disclaimer',
    Disclaimer: 'Descargo de responsabilida',
    DisclaimerText1: entityName() + ' confirma que asume la responsabilidad de la correspondencia de las opciones de cobertura específicas y que el Cuestionario presentado refleja correctamente las solicitudes de los clientes, especialmente cuando el Formulario de Propuesta se completa por separado y/o se firma sin la ayuda de la herramienta de firma remota.',
    DisclaimerText2: entityName() + ' confirma también que la información contenida en el Formulario de Oferta y Propuesta adjunto (cuando éste constituye un documento separado) es, a su leal saber y entender, veraz y completa',
    IAgreeToTheTermsAndConditions: 'Estoy de acuerdo con los términos y las condiciones',
    Submit: 'Enviar',
    Cancel: 'Cancelar',
    SendRequestToIssuePolicy: 'Enviar solicitud para emitir la póliza',
    ConfirmAndSubmit: 'Confirmar y Enviar',
    Signed: 'Firmado',
    ResetForm: 'Restablecer formulario',
    UploadComplete: 'Carga completada',
    UploadSuccessMessage: 'Documentos cargados satisfactoriamente',
    ErrorOccurred: 'Se ha producido un error',
    UploadFailureMessage: 'No se pueden cargar los documentos. Por favor, inténtelo de nuevo.',
    CategoriesFetchFailureMessage: 'No se pueden recuperar las categorías. Por favor, inténtelo de nuevo.',
    DocumentTypesFetchFailureMessage: 'No se puede recuperar este tipo de documentos. Por favor, inténtelo de nuevo.',
    DownloadNoItemsSelectedMessage: 'Por favor, seleccione uno o más elementos.',
    UsersFetchFailureMessage: 'No se puede recuperar la lista de usuarios. Por favor, inténtelo de nuevo.',
    DashboardChartFailureMessage: 'No se pueden recuperar los datos del gráfico.Por favor, inténtelo de nuevo.',
    UploadMultiUploadText: 'Elegir un archivo o arrastrar aquí',
    UploadMultiUploadTextBefore: 'Soltar ficheros aquí o',
    UploadMultiUploadTextAfter: 'cargar',
    ClickHere: 'haga clic aquí',
    DownloadFileFailureMessage: 'No ha sido posible descargar el documento. Por favor, inténtelo de nuevo.',
    DownloadSuccessMessage: 'El fichero esta listo para ser descargado',
    DownloadEmailSuccessMessage: 'Tu descarga se esta procesando y se le enviará un enlace por correo electrónico una vez finalizada.',
    Close: 'Cerrar',
    UnableToLoadDataset: 'No se puede cargar el conjunto de datos',
    Download: 'Descargar',
    ConfirmDownload: 'Confirmar descarga',
    ConfirmDownloadMessage: '¿Está seguro de que deseas descargar estos elementos?',
    InvalidFileType: 'Tipo de archivo invalido',
    InvalidFileSize: 'Tamaño de archivo no válido. El tamaño máximo es de ',
    ExcelRaterFileTypesAllowed: 'Solo se permiten archivos .xlsx y .xlsm',
    ProposalFileTypesAllowed: 'Solo se permiten archivos .docx y .pdf',
    SubmissionDate: 'Fecha de solicitud',
    CertificatePolicyNo: 'Número de certificado',
    InsuredSurname: 'Apellido asegurado',
    ClassOfBusiness: 'Clase de Business',
    Profession: 'Profesión',
    AddressLine1: 'Dirección',
    GeneratedServiceCode: 'Propuesta Nº',
    SubmissionStatus: 'Estado',
    IsRemoteSignature: 'Firma Digital',
    IsReferral: 'Referal',
    SubmitterNote: 'Nota',
    PolicyIssueDate: 'Fecha de emisión de la póliza',
    InsuredTurnover: 'Ventas',
    RetroactiveDate: 'Retroactividad',
    RetroactivePeriod: 'Periodo de retroactividad',
    Raters: 'Raters',
    IPID: 'IPID',
    ProductSheet: 'Ficha de producto',
    ProposalForm: 'Formulario de propuesta',
    InformationBooklet: 'Folleto informativo',
    Wording: 'Texto de la políza',
    DownloadAllOfflineRaters: 'Descargar Offline Raters',
    StandardSignatureText: 'Es preciso subir el Cuestionario y Tarificador.  La póliza se emitirá en 48 horas.',
    RemoteSignatureText: 'Únicamente se precisa subir el Tarificador. Cuando el Tomador firme electrónicamente, la póliza se emitirá inmediatamente.',
    UploadFormExcelProposal: 'Cargar el rater excel y cuestionario',
    UploadFormExcel: 'Cargar el rater excel',
    FirmOrderSubmitted: 'Orden de Emisión Subida',
    ThankYouForYourSubmission: 'Muchas gracias por su solicitud',
    ViewSubmission: 'Ver Orden en Firme',
    UploadAnother: 'Subir Otro',
    UploadFailed: 'Descarga fallida',
    UploadFailedMessage: 'Por favor, vuelva a las Herramientas de Suscripción o intente de nuevo la descarga a continuación',
    Retry: 'Reintentar',
    SelectSignature: 'Selecciona la forma de firma',
    AddYourFileSingular: 'Cargar tu archivo',
    AddYourFilePlural: 'Cargar tus archivos',
    DownloadComplete: 'Descarga completa',
    YourDownloadIsReady: 'Su descarga está lista',
    ClickLinkToDownload: 'Haga clic en el siguiente enlace para comenzar la descarga',
    DownloadFile: 'Descargar archivo',
    DownloadingFile: 'Descargar archivo',
    ProcessingDownload: 'Estamos procesando su descarga',
    DownloadingMessage: 'Una vez que la descarga esté lista, aparecerá un enlace a continuación. Por favor, mantenga esta pestaña activa. ',
    ProcessCanTakeFewMinutes: 'Este proceso puede durar unos minutos',
    Ready: 'Listo',
    Failed: 'Fallido',
    DownloadFailed: 'Descarga fallida',
    SomethingWentWrong: 'Algo ha ido mal',
    NoRecordsFound: 'Ningún record encontrado...',
    GoBackToUnderwritingTools: 'Por favor, vuelva a las Herramientas de suscripción o intente de nuevo la descarga a continuación',
    PleaseContactHelpDesk: 'Para soporte, por favor contactar a helpdesk@fides.international',
    ReturnToUnderwritingTools: 'Volver a Herramientas de suscripción',
    SelectOption: 'Seleccione una opción',
    FirmOrderAndReferrals: 'Orden de Emisión y Referral',
    RequestNotProperlyReceived: 'Presentación no tramitadas',
  },
}
